/**
 * Context-aware card resolver for the Finance AI chat panel.
 *
 * Determines which action card (if any) to show based on where the user
 * opened the AI panel from and the current state of the entity.
 */

import type { ChatOrigin } from '@/components/ai-chat/hooks/useFinanceAgentChat';

export type ActionCardType = 'bank_line_match_picker' | 'bank_line_classify' | 'psp_line_picker' | 'none';

export function resolveActionCard(origin: ChatOrigin | null): ActionCardType {
  if (!origin) return 'none';

  switch (origin.type) {
    case 'bank_line': {
      // Pending → classify card (AI suggests classification type).
      // Classified/other → no pre-response card. The prompt already asks the AI
      // to find matches, and MatchSuggestionCard appears from the response.
      if (origin.line.reconciliation_status === 'pending') return 'bank_line_classify';
      return 'none';
    }
    case 'dashboard':
      if (origin.lifecycleId === 'bank_statements') return 'bank_line_match_picker';
      if (origin.lifecycleId === 'psp_matching') return 'psp_line_picker';
      return 'none';
    case 'psp_matching':
      // User already on a specific line (opened from workspace "Ask AI") → no picker card.
      if (origin.lineId) return 'none';
      return 'psp_line_picker';
    default:
      return 'none';
  }
}
